module.exports = __webpack_public_path__ + "img/LikeIcon.3a4fb165.svg";